/* istanbul ignore file */
export default {
  equals: 'Equals',
  isGreaterThan: 'Is Greater Than',
  isLessThan: 'Is Less Than'
};
